const EDIT_SPORT_DRAFT_PREFIX = 'admin:sportDraft:edit:'
export const NEW_SPORT_DRAFT_KEY = 'admin:sportDraft:new'

const SPORT_DRAFT_FIELDS = [
    'type',
    'category',
    'title',
    'phone',
    'country',
    'area',
    'address',
    'addressDetail',
    'latitude',
    'longitude',
    'openingHours',
    'info',
    'price1',
    'price1Sale',
    'price3',
    'price3Sale',
    'price6',
    'price6Sale',
    'price12',
    'price12Sale',
    'neeGym',
    'daGym',
    'phoneTime',
    'postTime',
    'memo',
]

const getSessionStorage = () => {
    if (typeof window === 'undefined') {
        return null
    }

    return window.sessionStorage
}

const serializeDateValue = (value) => {
    if (value === null) {
        return null
    }

    if (value === undefined || value === '') {
        return ''
    }

    const nextDate = new Date(value)

    return Number.isNaN(nextDate.getTime()) ? '' : nextDate.toISOString()
}

const parseDateValue = (value, fallbackValue) => {
    if (value === null) {
        return null
    }

    if (value === undefined || value === '') {
        return fallbackValue
    }

    const nextDate = new Date(value)

    return Number.isNaN(nextDate.getTime()) ? fallbackValue : nextDate
}

const normalizeFlagValue = (value, fallbackValue = 0) => {
    if (value === '' || value === null || value === undefined) {
        return fallbackValue
    }

    const parsedValue = Number(value)

    return Number.isNaN(parsedValue) ? fallbackValue : parsedValue
}

const normalizeCheckOptions = (checked = []) => {
    return [...checked].filter(Boolean).map(String).sort()
}

// 운동시설 폼에서 실제로 이어서 수정해야 하는 값만 sessionStorage에 남긴다.
export const createSportDraftPayload = ({
    params = {},
    checked = [],
    uploadFiles = [],
    openModal = false,
}) => {
    return {
        params: {
            type: normalizeFlagValue(params.type, 1),
            category: normalizeFlagValue(params.category, 1),
            title: params.title || '',
            phone: params.phone || '',
            country: params.country || '',
            area: params.area || '',
            address: params.address || '',
            addressDetail: params.addressDetail || '',
            latitude: params.latitude || '',
            longitude: params.longitude || '',
            openingHours: params.openingHours || '',
            info: params.info || '',
            price1: params.price1 || '',
            price1Sale: params.price1Sale || '',
            price3: params.price3 || '',
            price3Sale: params.price3Sale || '',
            price6: params.price6 || '',
            price6Sale: params.price6Sale || '',
            price12: params.price12 || '',
            price12Sale: params.price12Sale || '',
            neeGym: normalizeFlagValue(params.neeGym, 0),
            daGym: normalizeFlagValue(params.daGym, 0),
            phoneTime: serializeDateValue(params.phoneTime),
            postTime: serializeDateValue(params.postTime),
            memo: params.memo || '',
        },
        checked: normalizeCheckOptions(checked),
        uploadFiles: Array.isArray(uploadFiles) ? [...uploadFiles] : [],
        openModal: Boolean(openModal),
    }
}

// 서버 기본값 위에 draft만 덮어써서 새로고침 뒤에도 입력 흐름을 이어간다.
export const applySportDraft = ({
    baseParams = {},
    baseChecked = [],
    baseUploadFiles = [],
    draft,
}) => {
    if (!draft) {
        return {
            params: baseParams,
            checked: baseChecked,
            uploadFiles: baseUploadFiles,
            openModal: false,
        }
    }

    const draftParams = draft.params || {}
    const nextParams = {
        ...baseParams,
    }

    SPORT_DRAFT_FIELDS.forEach((field) => {
        if (draftParams[field] === undefined) {
            return
        }

        if (field === 'phoneTime' || field === 'postTime') {
            nextParams[field] = parseDateValue(draftParams[field], baseParams[field] ?? null)
            return
        }

        nextParams[field] = draftParams[field]
    })

    return {
        params: nextParams,
        checked: normalizeCheckOptions(draft.checked || baseChecked),
        uploadFiles: Array.isArray(draft.uploadFiles) ? [...draft.uploadFiles] : baseUploadFiles,
        openModal: Boolean(draft.openModal),
    }
}

export const createEditSportDraftKey = (sportsId) => `${EDIT_SPORT_DRAFT_PREFIX}${sportsId}`

export const readSportDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return null
    }

    try {
        const storedValue = storage.getItem(draftKey)
        return storedValue ? JSON.parse(storedValue) : null
    } catch (_error) {
        return null
    }
}

export const saveSportDraft = (draftKey, draftValue) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.setItem(draftKey, JSON.stringify(draftValue))
    } catch (_error) {
        // sessionStorage가 막혀 있어도 입력 흐름은 그대로 유지한다.
    }
}

export const clearSportDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.removeItem(draftKey)
    } catch (_error) {
        // storage 정리에 실패해도 화면 동작은 계속 진행한다.
    }
}
